// Check frequency for expired auth sessions
export const AUTH_EXP_CHECK_INTERVAL = 60 * 1000

// Key used to serialize user to localStorage
export const AUTH_LS_USER_KEY = 'ps_auth_user'



// WEBPACK FOOTER //
// ./src/store/modules/auth/auth.constants.js